import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader2, PackagePlus } from 'lucide-react';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { cartAPI, promosAPI } from '../services/api';
import { vehicleStore } from '../services/vehicleStore';
import { promoSession, PENDING_PROMO_KEY } from '../services/savings';
import { useT } from '../services/i18n';
import { prodName } from '../services/catalogI18n';

const eur = (n) => `${Number(n || 0).toFixed(2)} €`;

// Cart: an engine oil without its additive → one-click bundle (additive at the pack discount)
export const CartPackUpsell = ({ items, vehicle, onAdded, onPromo }) => {
  const { t, lang } = useT();
  const [pack, setPack] = useState(null);
  const [busy, setBusy] = useState(false);
  const ids = (items || []).map(i => i.product_id).sort().join(',');
  useEffect(() => {
    if (!ids) { setPack(null); return; }
    cartAPI.packUpsell(ids.split(','), vehicle ? vehicleStore.toParams(vehicle) : {}).then(setPack).catch(() => setPack(null));
  }, [ids, vehicle?.brand, vehicle?.model, vehicle?.engine?.name]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!pack?.available) return null;
  const add = async () => {
    setBusy(true);
    try {
      await cartAPI.addItem(pack.additive.id, 1);
      if (localStorage.getItem('token')) {
        const res = await promosAPI.validate(pack.code);
        promoSession.set(res);
        onPromo?.(res);
        toast.success(t('packEss.added', { c: pack.code }));
      } else {
        sessionStorage.setItem(PENDING_PROMO_KEY, pack.code);
        toast.success(t('packEss.addedLogin', { c: pack.code }));
      }
      onAdded?.();
    } catch (e) {
      // toast already shown by cartAPI
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="border border-emerald-200 bg-emerald-50/60 rounded-lg p-3 mb-4" data-testid="cart-pack-upsell" data-energy={pack.energy}>
      <p className="text-sm font-semibold text-gray-900 flex items-center gap-2"><PackagePlus size={16} className="text-emerald-600" /> {t(pack.energy === 'diesel' ? 'packEss.titleDiesel' : 'packEss.title')}</p>
      <p className="text-xs text-gray-600 mt-0.5">{t('packEss.cartDesc', { p: pack.percent.toFixed(0) })}</p>
      <div className="mt-2 flex items-center gap-2">
        <Link to={`/produit/${pack.additive.slug || pack.additive.id}`} className="shrink-0"><img src={pack.additive.image} alt="" className="w-12 h-12 object-contain bg-white rounded border border-gray-200" /></Link>
        <div className="min-w-0 flex-1">
          <p className="text-xs font-medium text-gray-900 line-clamp-2" data-testid="cart-pack-additive-name">{prodName(pack.additive, lang)}</p>
          <p className="text-xs"><span className="line-through text-gray-400">{eur(pack.additive.price)}</span> <span className="font-bold text-emerald-700" data-testid="cart-pack-price">{eur(pack.additive_discounted)}</span> <span className="text-emerald-700">(-{eur(pack.discount)})</span></p>
        </div>
      </div>
      <Button onClick={add} disabled={busy} size="sm" className="mt-2 w-full bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="cart-pack-add">
        {busy ? <Loader2 size={14} className="mr-1 animate-spin" /> : <PackagePlus size={14} className="mr-1" />} {t('packEss.cartAdd', { p: pack.percent.toFixed(0) })}
      </Button>
    </div>
  );
};

export default CartPackUpsell;
